export const maxFiveMb = 5 * 1024 * 1024;
export const maxThirtyMb = 30 * 1024 * 1024;
